<template>
  <div class="content">
    <ChannelOperator :channel="channel"/>
    <!-- Tab切换区域 -->
    <el-card class="tab-card" style="margin-top: 20px;">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基础信息" name="basic">
          <div class="tab-content">
            <!-- 基础信息内容区域 -->
            <el-form :model="basicForm" label-width="120px">
              <!-- 表单内容 -->
              <el-form-item label="渠道名称">
                <el-input v-model="basicForm.name" placeholder="请输入渠道名称" />
              </el-form-item>
              <el-form-item label="渠道类型">
                <el-select v-model="basicForm.type" placeholder="请选择渠道类型">
                  <el-option label="自有渠道" value="self" />
                  <el-option label="合作渠道" value="cooperation" />
                </el-select>
              </el-form-item>
              <!-- 更多表单项 -->
            </el-form>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="高级设置" name="advanced">
          <div class="tab-content">
            <!-- 高级设置内容区域 -->
            <el-form :model="advancedForm" label-width="120px">
              <!-- 高级设置表单内容 -->
            </el-form>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="数据统计" name="statistics">
          <div class="tab-content">
            <!-- 数据统计内容区域 -->
            <el-table :data="statisticData">
              <!-- 统计表格列 -->
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    
  </div>
</template>

<script>
import ChannelOperator from '@/views/international/channel/source/ChannelOperator.vue'
export default {
  data() {
    return {
      channel:'Quadcell',
      // Tab相关数据
      activeTab: 'basic',
      // 表单数据
      basicForm: {
        name: '',
        type: ''
      },
      advancedForm: {},
      // 统计数据
      statisticData: [],
    }
  },
  components: {
    ChannelOperator
  },
  methods: {
    
  }
}
</script>

<style scoped lang="less">

</style>
